import { html } from "lit";
import {
    getPlaceholderUrl,
    getDummyText,
    renderStandardPictureElement,
} from "../../../utils";

export const productSliderZoomSlide = (
    text,
    imagePath,
    title = getDummyText(30)
) => html`
    <div class="block block-hero block-hero-subpage no-gutter">
        <div class="block-image">
            <picture
                ><source
                    media="(max-width: 567px)"
                    data-srcset="./mock-assets/green-market-form/${imagePath}"
                    class="ux-slider-lazy-img" />
                <source
                    media="(max-width: 1024px)"
                    data-srcset="./mock-assets/green-market-form/${imagePath}"
                    class="ux-slider-lazy-img" />
                <source
                    data-srcset="./mock-assets/green-market-form/${imagePath}"
                    class="ux-slider-lazy-img" />
                <img
                    class="ux-slider-lazy-img"
                    alt="17:8 standard - viewport test images /w Retina support"
                    data-srcset="./mock-assets/green-market-form/${imagePath}"
                    src=${getPlaceholderUrl(1920, 902)}
            /></picture>
        </div>
        <div class="block-zoom-image">
            <picture
                ><img
                    class="ux-slider-lazy-img"
                    data-src="./mock-assets/green-market-form/${imagePath}"
                    src=${getPlaceholderUrl(1920, 902)}
                    alt="TruLaser Tube 7000 fiber, RapidCut"
            /></picture>
        </div>
        <div class="block-content">
            <span class="text-tiny u-uppercase u-block"
                ><strong>${getDummyText(28)}</strong></span
            >
            <h2 class="headline-big">
                ${title}
            </h2>
            <div class="block-content-text">
                <p class="text-normal">
                    ${text}
                </p>
            </div>
            <div class="block-button u-textCenter">
                <a class="btn btn-green js-jumpToTab" href="#tabEquipment"
                    >SABER MÁS</a
                >
            </div>
            <div class="ux-slider-inline-pagination-anchor"></div>
        </div>
        <div class="block-shadow"></div>
        <div class="btn-zoom-wrapper">
            <a class="btn-zoom" href="#" data-ux-slider-slide-zoom="zoom"
                ><i class="icon-zoomin" style="background-image: none;"
                    ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        style="enable-background:new 0 0 16 16"
                    >
                        <path
                            d="M10 6V0H9v7h7V6zM0 9v1h6v6h1V9H6z"
                        ></path></svg></i
                ><i class="icon-zoomout" style="background-image: none;"
                    ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 13 13"
                        style="enable-background:new 0 0 13 13"
                    >
                        <path
                            d="M12 0H6v1h6v6h1V0zM1 6H0v7h7v-1H1z"
                        ></path></svg></i
            ></a>
        </div>
    </div>
`;

export const heroSliderSlide = html`
    <div class="ux-block-hero ux-iws-block-hero-slide">
        <div class="ux-block-hero__image">
            ${renderStandardPictureElement({
                width: 1024,
                height: 482,
            })}
        </div>
        <div class="ux-block-hero__content">
            <h2 class="ux-text-headline ux-text-headline--big">
                The Power of Choice
            </h2>
            <p class="ux-text-normal ux-text-normal--light-gray">
                Entdecken Sie jetzt die Exponate von TRUMPF auf der Messe LASER
                2015
            </p>
            <div class="ux-block-hero__button-block">
                <a href="#" class="ux-button ux-button--green">
                    Mehr Erfahren
                </a>
            </div>
            <div class="ux-slider-inline-pagination-anchor"></div>
        </div>
    </div>
`;

export const heroSliderSlideMultipleButtons = html`
    <div class="ux-block-hero ux-iws-block-hero-slide">
        <div class="ux-block-hero__image">
            ${renderStandardPictureElement({
                width: 1024,
                height: 482,
            })}
        </div>
        <div class="ux-block-hero__content">
            <h2 class="ux-text-headline ux-text-headline--big">
                The Power of Choice
            </h2>
            <p class="ux-text-normal ux-text-normal--light-gray">
                Entdecken Sie jetzt die Exponate von TRUMPF auf der Messe LASER
                2015
            </p>
            <div class="ux-block-hero__button-block">
                <a href="#" class="ux-button ux-button--green">
                    Mehr Erfahren
                </a>
                <a href="#" class="ux-button">
                    ICal
                    <ux-icon
                        name="square-arrow-in"
                        class="ux-u-ml-xxxs"
                    ></ux-icon>
                </a>
            </div>
            <div class="ux-slider-inline-pagination-anchor"></div>
        </div>
    </div>
`;

export const teaser2fachBoldSlide = html`
    <ux-iws-link-wrapper class="ux-u-shadow">
        <div class="block-image">
            ${renderStandardPictureElement({
                width: 1920,
                height: 1080,
            })}
        </div>
        <div class="block-content" style="box-sizing: border-box;">
            <div class="block-content-hdl">
                <div class="text-big ">
                    Skalpell mit UDI-Code
                </div>
            </div>
            <div class="block-content-text">
                <div class="text-normal ">
                    <p>
                        Die Rückverfolgbarkeit ist in der Herstellung
                        medizintechnischer Produkte von hoher Bedeutung. Daher
                        spielt das berührungslose Black Marking eine
                        herausragende Rolle: Mit den extremen
                        Pulsspitzenleistungen der TruMark Ultrakurzpulslaser
                        erzeugen Sie tiefschwarze, korrosionsfreie UDI-Codes.
                    </p>
                </div>
                <div class="text-normal ">
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        (72 characters)
                    </p>
                </div>
            </div>
            <div class="block-button u-textCenter">
                <a href="#" class="btn">
                    Button
                </a>
            </div>
        </div>
    </ux-iws-link-wrapper>
`;

export const videoSliderSlide = html` <div
        class="gr-12 u-textCenter u-marginBottom-50 u-marginTop-50 u-headline-inModule"
    >
        <h3 class="headline-medium ">
            Headline Med 1.75em // 28px
        </h3>
    </div>
    <div class="gr-12">
        <ux-video>
            <video controls>
                <source
                    src="https://www.trumpf.com/filestorage/TRUMPF_Master/Corporate/Company_profile/Imagevideo-TRUMPF-Group-DE.mp4"
                    type="video/mp4"
                />
            </video>
        </ux-video>
    </div>
    <div class="gr-12 u-textLeft caption">
        <div class="text-medium ">
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. (72
                characters)
            </p>
        </div>
    </div>`;

export const contactCardSliderSlide = html` <div class="ux-iws-teaser-contact">
    <div class="ux-iws-teaser-contact__inner">
        <div class="ux-iws-teaser-contact__information">
            <div class="ux-iws-teaser-contact__image-wrapper">
                <picture>
                    <source
                        media="(max-width: 567px)"
                        srcset="
                            ./mock-assets/images/contact-person.png,
                            ./mock-assets/images/contact-personx2.png 2x
                        "
                    />
                    <source
                        media="(max-width: 1024px)"
                        srcset="
                            ./mock-assets/images/contact-person.png,
                            ./mock-assets/images/contact-personx2.png 2x
                        "
                    />
                    <source
                        srcset="
                            ./mock-assets/images/contact-person.png,
                            ./mock-assets/images/contact-personx2.png 2x
                        "
                    />
                    <img
                        src="./mock-assets/images/contact-person.png"
                        alt="square-3x4 - 33 square Image"
                    />
                </picture>
            </div>
            <div class="ux-iws-teaser-contact__name-title">
                <p class="ux-text-normal">Christos Papadopulos</p>
                <div class="ux-text-tiny ux-u-text-uppercase">
                    <strong>Role in the company</strong>
                </div>
            </div>
            <div class="ux-iws-teaser-contact__contacts">
                <a href="#" class="ux-text-link ux-text-link--green"
                    >iryna@trumpf.com</a
                >
                <a href="#" class="ux-text-link ux-text-link--green"
                    >+49 152 4427217</a
                >
            </div>
        </div>
    </div>
</div>`;

export const contactCardSliderSlideExtended = html` <div
    class="ux-iws-teaser-contact ux-iws-teaser-contact--extended"
>
    <div class="ux-iws-teaser-contact__inner">
        <div class="ux-iws-teaser-contact__information">
            <div class="ux-iws-teaser-contact__name-title">
                <div
                    class="ux-iws-teaser-contact__title ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                >
                    Christos Papadopulos
                </div>
            </div>
            <div class="ux-iws-teaser-contact__contacts">
                <div class="ux-iws-teaser-contact__mail">
                    <a href="#" class="ux-text-link ux-text-link--green"
                        >M: tcn.spc.fd03@trumpf.com (MT_East)
                        (机床部华东区客户商务支持邮箱)</a
                    >
                    <a href="#" class="ux-text-link ux-text-link--green"
                        >M: tcn.spc.fd04@trumpf.com (MT_South)
                        (机床部华南区客户商务支持邮箱)</a
                    >
                    <a href="#" class="ux-text-link ux-text-link--green"
                        >M: tcn.spc.fd05@trumpf.com (MT_Ext.East&South)
                        (机床部非华东华南区客户商务支持邮箱)</a
                    >
                </div>
                <div class="ux-iws-teaser-contact__phone">
                    <a href="#" class="ux-text-link ux-text-link--green"
                        >T: 400-828-5030 (MT Service Hotline)
                        (机床部全国服务热线</a
                    >
                </div>
            </div>
            <div class="ux-iws-teaser-contact__business-hours">
                <div
                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                >
                    服务时间:
                </div>
                <div class="ux-text-normal">
                    周一 ~ 周五:上午8:30 ~下午5:30
                </div>
            </div>
        </div>
    </div>
</div>`;

export const quoteSliderSlide = html` <div class="quote-noImg">
    <i class="icon-quotation_down" data-grunticon-embed=""></i>
    <h3 class="headline-small ">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
        eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
        voluptua. At vero eos et accusam et justo duo ea rebum.
    </h3>
    <div class="quote-list-single-grfx"></div>

    <div class="text-tiny u-uppercase ">
        <strong>Heinrich Babbel</strong>
    </div>
    <div class="text-tiny u-uppercase">Entwicklungsingenieur</div>
    <i class="icon-quotation_up" data-grunticon-embed=""></i>
</div>`;

export const quoteSlider2Slide = html` <div class="u-clearfix u-relPos">
    <div class="gr-5 push-1 gr-10@t768 push-1@t768 gr-10@m push-1@m no-gutter">
        ${renderStandardPictureElement({
            width: 1920,
            height: 1080,
        })}
    </div>
    <div
        class="gr-1 push-1 gr-10@t768 push-1@t768 no-gutter@t768 gr-10@m push-1@m no-gutter@m"
    >
        <div class="quote-list-single-grfx">
            ${renderStandardPictureElement({
                width: 1920,
                height: 1080,
            })}
        </div>
    </div>
    <div class="gr-4 push-1 gr-10@t768 push-1@t768 gr-10@m push-1@m no-gutter">
        <i class="icon-quotation_down"></i>
        <h3 class="headline-small">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo ea
            rebum.
        </h3>
        <div class="text-tiny u-uppercase ">
            <strong>Heinrich Babbel</strong>
        </div>

        <div class="text-tiny u-uppercase">
            Seniorberater der Avermann Laser- und Kant- Zentrum GmbH
        </div>
        <i class="icon-quotation_up"></i>
    </div>
</div>`;

export const productSliderSlide = html` <div class="block-image">
        <div class="stoerer-wrapper">
            <div class="stoerer ">
                <div class="stoerer-content blue">
                    <span class="title-normal">Störer x</span>
                </div>
            </div>
        </div>
        ${renderStandardPictureElement({
            width: 530,
            height: 464,
        })}
    </div>
    <div class="block-content u-shadow" data-same-height="item">
        <div class="text-tiny u-uppercase ">
            <strong>Medium Title</strong>
        </div>
        <div class="title-normal ">
            Block Title
        </div>
        <div class="text-small u-color-gray-paragraph">
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. (72
                characters)
            </p>
        </div>

        <div class="block-button">
            <a
                href="https://www.google.de"
                class="ux-button ux-button--icon-only"
            >
                <ux-icon name="chevron-right"></ux-icon>
            </a>
        </div>
    </div>`;

export const tripleSliderSlide = html` <div class="block">
    <div class="block-image">
        ${renderStandardPictureElement({
            width: 530,
            height: 300,
        })}
    </div>
    <div class="block-content u-shadow" data-sameheight="item">
        <div class="block-content-headline" data-sameheight="headline">
            <div class="title-normal">
                Headline Item
            </div>
        </div>
        <div class="block-content-text" data-sameheight="text">
            <div class="text-normal u-color-gray-paragraph">
                <p>
                    Mi dis sociosqu per lobortis praesent tristique magna vel
                    sagittis facilisis, vitae volutpat turpis potenti, lacus
                    primis taciti hac ornare malesuada rhoncus diam eu. Sed orci
                    ac cursus primis quam volutpat, malesuada in eros gravida
                    nibh. Tempor nam tortor rutrum nisi ad amet dui tempus nunc,
                </p>
            </div>
        </div>
    </div>
</div>`;

export const notificationBigSliderSlide = html`
    <div class="row">
        <div class="gr-6 gr-12@t no-gutter@t gr-12@m no-gutter@m">
            ${renderStandardPictureElement({
                width: 785,
                height: 442,
            })}
        </div>
        <div class="gr-6 gr-12@t no-gutter@t gr-12@m no-gutter@m">
            <h2 class="headline-big">
                Willkommen bei MyTrumpf
            </h2>
            <div class="text-medium">
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                    Reiciendis vitae amet provident repellendus esse consequatur
                    id magni repellat, quisquam quaerat voluptatum culpa
                    necessitatibus, quo minima perspiciatis voluptates velit
                    nulla adipisci.
                </p>
            </div>
        </div>
    </div>
`;

export const galerieSliderSlide = html` <div
    class="gr-10 push-1 gr-12@m push-0@m"
>
    ${renderStandardPictureElement({
        width: 1920,
        height: 904,
    })}
    <div class="gr-12 u-no-padding">
        <h2 class="headline-small">
            Headline Small 1.43em // 23px
        </h2>
        <div class="text-normal ">
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. (72
                characters)
            </p>
        </div>
        <div class="u-textCenter">
            <a href="#" class="ux-button">
                Button
            </a>
        </div>
    </div>
</div>`;

export const galerieSliderSlideV2 = html` <div
    class="gr-10 push-1 gr-12@m push-0@m"
>
    ${renderStandardPictureElement({
        width: 1920,
        height: 904,
    })}
    <div class="gr-12 u-no-padding">
        <h2 class="headline-small">
            Headline Small 1.43em // 23px
        </h2>
        <div class="text-normal ">
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. (72
                characters) <br />
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. (72
                characters)
            </p>
        </div>
        <div class="u-textCenter">
            <a href="#" class="ux-button">
                Button
            </a>
        </div>
    </div>
</div>`;

export const newHomepageSlide = (titleText, width, height) => {
    return html`
        <div class="ux-block-hero">
            <div class="ux-block-hero__image">
                ${renderStandardPictureElement({
                    width: width,
                    height: height,
                })}
            </div>
            <div
                class="ux-block-hero__content ux-block-hero__content--no-overlap"
            >
                <span class="ux-text-small ux-text-small--bold">
                    SMART FACTORY
                </span>
                <h2 class="ux-text-headline ux-text-headline--big">
                    ${titleText}
                </h2>
                <p class="ux-text-normal ux-text-normal--light-gray">
                    Tauchen Sie ein in die Erfolgsgeschichten unserer Kunden und
                    lassen Sie sich inspirieren, wie auch Sie Ihre Fertigung
                    durch clevere Vernetzung.
                </p>
                <button class="ux-button">Mehr erfahren</button>
            </div>
        </div>
    `;
};

export const productImageSliderSlide = html`
    <div class="gr-10 push-1 gr-12@m push-0@m">
        ${renderStandardPictureElement({
            width: 2880,
            height: 1620,
        })}
        <div class="gr-10 push-1">
            <h2 class="headline-small">
                Individualisierung von Lippenstiften
            </h2>
            <div class="text-normal">
                <p>
                    Gerade für die Individualisierung kleiner Serien eignet sich
                    die TruMark Station 1000 hervorragend. So können
                    beispielsweise Give-Aways in Form von individualisierten
                    Lippenstiften direkt vor Ort auf einer Veranstaltung
                    markiert werden. Bei dem hier eingesetzten Verfahren werden
                    Farbstoffmoleküle gezielt verfärbt oder ausgebleicht. Die
                    Oberfläche bleibt dabei glatt.
                </p>
            </div>
        </div>
    </div>
`;
